module.exports = __webpack_public_path__ + "static/media/DINNextLTProUltraLight.beee8f8b.woff";